<mat-icon class="btn-close" mat-dialog-close>close</mat-icon>
<p>
  {{ data }}
</p>
